import React from 'react'
import { findWhere } from 'underscore'

import { postViewHistory } from '~/actions/viewhistory'
import { getStatement, getReplies } from '~/actions/statement'

import Statement from './components/StatementPart'
import NoStatement from './components/NoStatementPart'


const getState = props => {
    var feedPost = findWhere(props.feed.posts, {url_slug: props.routeParams.slug})
    if( !!feedPost ) return { statement: feedPost }
    return {};
};

export default class extends React.Component {
    state = getState(this.props);

    componentWillMount() {
		if( !this.state.statement ) this.props.dispatch( getStatement( this.props.routeParams.slug ) )
		this.props.dispatch( getReplies(  this.props.routeParams.slug ) )
	}

    componentDidMount() {
		this.props.dispatch( postViewHistory( 'statements', this.props.routeParams.slug ) )
	}

    render() {

		var statement = this.state.statement ? this.state.statement : this.props.statement.post,
			fetching = this.props.statement.fetching,
			replies = this.props.statement.replies;

		return (
			<div className="container">
				<div className="row">
		            <div className="post col-md-8 col-md-offset-2">
		            	{( !!statement.title
		            		? <Statement replies={replies} {...statement} dispatch={this.props.dispatch} />
			            	: <NoStatement />
			            )}
					</div>
				</div>
			</div>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Statement/index.jsx